<script>
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';
import googleAdsAPI from 'dashboard/api/googleAds';

export default {
  components: {
    NextButton,
  },
  data() {
    return {
      connections: [],
      loading: false,
      testingId: null,
    };
  },
  computed: {
    readyConnections() {
      return this.connections.filter(c => c.customer_id);
    },
  },
  mounted() {
    this.fetchConnections();
  },
  methods: {
    connectionTitle(conn) {
      if (conn.name) return `${conn.name} (${conn.customer_id})`;
      return conn.customer_id;
    },
    goToConnections() {
      this.$router.push({
        query: { ...this.$route.query, tab: 'connections' },
      });
    },
    async fetchConnections() {
      this.loading = true;
      try {
        const { data } = await googleAdsAPI.get();
        this.connections = data;
      } finally {
        this.loading = false;
      }
    },
    async test(conn) {
      this.testingId = conn.id;
      try {
        await googleAdsAPI.test(conn.id);
        useAlert(this.$t('META_ADS.CONVERSIONS.TEST.SUCCESS'));
      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.error) ||
          '';
        useAlert(
          `${this.$t('META_ADS.CONVERSIONS.TEST.ERROR')} ${message}`.trim()
        );
      } finally {
        this.testingId = null;
      }
    },
  },
};
</script>

<template>
  <div class="flex flex-col w-full max-w-[60rem] gap-6 mx-auto">
    <div class="min-w-0">
      <h1 class="text-xl font-medium text-n-slate-12">
        {{ $t('META_ADS.CONVERSIONS.HEADER') }}
      </h1>
      <p class="mt-1 text-sm text-n-slate-10">
        {{ $t('META_ADS.CONVERSIONS.DESCRIPTION') }}
      </p>
    </div>

    <div
      v-if="!loading && !readyConnections.length"
      class="flex flex-col items-center gap-3 p-6 text-sm text-center rounded-xl text-n-slate-11 bg-n-solid-2"
    >
      {{ $t('META_ADS.CONVERSIONS.NO_CONNECTION') }}
      <NextButton
        icon="i-lucide-plug"
        :label="$t('META_ADS.CONNECTIONS.GO')"
        sm
        @click="goToConnections"
      />
    </div>

    <div
      v-for="conn in readyConnections"
      :key="conn.id"
      class="flex items-center justify-between gap-4 p-5 rounded-xl bg-n-solid-2"
    >
      <div class="flex items-center gap-2 min-w-0">
        <span class="i-lucide-line-chart text-n-slate-11 text-lg shrink-0" />
        <p class="font-medium truncate text-n-slate-12">
          {{ connectionTitle(conn) }}
        </p>
      </div>
      <NextButton
        icon="i-lucide-badge-check"
        :label="$t('META_ADS.CONVERSIONS.TEST.BUTTON')"
        :is-loading="testingId === conn.id"
        slate
        faded
        sm
        @click="test(conn)"
      />
    </div>

    <div class="flex flex-col gap-2 p-5 rounded-xl bg-n-solid-2">
      <h2 class="text-base font-medium text-n-slate-12">
        {{ $t('META_ADS.CONVERSIONS.SETUP.TITLE') }}
      </h2>
      <ol
        class="flex flex-col gap-1 pl-5 text-sm list-decimal text-n-slate-11 marker:text-n-slate-10"
      >
        <li>{{ $t('META_ADS.CONVERSIONS.SETUP.STEP1') }}</li>
        <li>{{ $t('META_ADS.CONVERSIONS.SETUP.STEP2') }}</li>
        <li>{{ $t('META_ADS.CONVERSIONS.SETUP.STEP3') }}</li>
      </ol>
    </div>
  </div>
</template>
